import React from "react";
import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";
import networkingHero from "../Assets/network.jpg";

const NetworkingServices = () => {
  return (
    <div>
      <Fixed />
      <div className="bg-gray-50 text-gray-900 pt-20">
        {/* Hero Section */}
        <section
          className="relative w-full h-screen flex items-center justify-center bg-cover bg-center text-center text-white"
          style={{ backgroundImage: `url(${networkingHero})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 px-6">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="text-5xl font-extrabold text-white"
            >
              Network Services & Solutions
            </motion.h1>
            <p className="mt-4 text-lg max-w-3xl mx-auto">
              Reliable and secure networking solutions to keep your business connected.
            </p>
          </div>
        </section>

        {/* Services Section */}
        <section className="container mx-auto px-6 py-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="bg-gradient-to-br from-blue-50 to-white shadow-lg rounded-lg p-10"
          >
            <h2 className="text-4xl font-bold text-blue-700 text-center">Our Network Solutions</h2>
            <p className="mt-4 text-lg text-gray-700 text-center">
              High-performance network services tailored for businesses and enterprises.
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  title: "Enterprise Networking",
                  description: "Robust and scalable networking solutions for businesses of all sizes.",
                },
                {
                  title: "Cloud Networking",
                  description: "Seamless integration of cloud-based networking for maximum efficiency.",
                },
                {
                  title: "Network Security",
                  description: "Advanced security solutions to protect your network from cyber threats.",
                },
              ].map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className="bg-white p-6 rounded-lg shadow-md border-b-4 border-blue-500"
                >
                  <h3 className="text-2xl font-semibold text-blue-600">{service.title}</h3>
                  <p className="mt-2 text-gray-700">{service.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </section>

        {/* Why Choose Us Section */}
        <section className="bg-gradient-to-r from-blue-50 to-white py-16">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold text-blue-800">Why Choose Our Network Services?</h2>
            <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
              Experience high-speed connectivity, secure networks, and seamless performance with our professional network services.
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-10">
              {[
                {
                  title: "High-Speed Connectivity",
                  description: "Optimized networks for fast and reliable performance.",
                  icon: "⚡",
                },
                {
                  title: "Secure Networks",
                  description: "Advanced security protocols to safeguard your data and connections.",
                  icon: "🔒",
                },
                {
                  title: "24/7 Support",
                  description: "Dedicated technical support to ensure uninterrupted operations.",
                  icon: "📞",
                },
              ].map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-blue-500 flex flex-col items-center"
                >
                  <div className="text-5xl">{feature.icon}</div>
                  <h3 className="text-2xl font-semibold text-blue-700 mt-4">{feature.title}</h3>
                  <p className="mt-2 text-gray-600 text-center">{feature.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="py-16 text-center bg-white border-t border-gray-300">
          <div className="container mx-auto px-6">
            <h2 className="text-4xl font-bold text-blue-800">Get Connected Today</h2>
            <p className="mt-4 text-lg text-gray-700">Enhance your business with our secure and high-performance network solutions.</p>
          </div>
        </section>
      </div>
      <Footer1 />
    </div>
  );
};

export default NetworkingServices;
